export default "<header>\n\n# Usability and User Experience Testing\n\nA practical chapter stub (WIP)\n\n</header>\n\nThis chapter is a work in progress.\n\n";